// src/pages/ChatBot/query-logs/chip-tones.ts
//
// Maps the derived query-log status and flag taxonomy to shared Tag tones, so
// status pills and flag chips render through one chassis (shared/Tag) with one
// colour vocabulary across the Queries table, Inspect modal, and Triage modal.
// This is the single source of truth for the former qlog-/qli-/qlt- chip
// colours.

import type { TagTone } from '../shared/Tag';
import type { QueryFlag, QueryStatusName } from './types';

const STATUS_TONE: Record<QueryStatusName, TagTone> = {
  Answered: 'green',
  Unanswered: 'amber',
  Incorrect: 'orange',
  Custom: 'blue',
  Error: 'red',
};

export function statusTone(status: QueryStatusName): TagTone {
  return STATUS_TONE[status];
}

// Warning flags read amber, the admin override reads blue, a user thumbs-up
// reads green, everything else (eval-set, …) reads neutral grey — mirroring
// the former qlog-flag-* classes.
export function flagTone(flag: QueryFlag): TagTone {
  if (flag.warning) return 'amber';
  if (flag.flag === 'override-served') return 'blue';
  if (flag.flag === 'positive-feedback') return 'green';
  return 'neutral';
}
